import { useEffect, useState } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { api } from "./lib/api";
import { parseStartParam } from "./lib/routing";
import { MeOut } from "./lib/schemas";
import AddExpense from "./pages/AddExpense";
import Balances from "./pages/Balances";
import ExpenseDetail from "./pages/ExpenseDetail";
import Group from "./pages/Group";
import History from "./pages/History";
import Home from "./pages/Home";
import Inbox from "./pages/Inbox";
import Receipt from "./pages/Receipt";
import ReceiptDetail from "./pages/ReceiptDetail";
import Settle from "./pages/Settle";

export default function App() {
  const nav = useNavigate();
  const [resolving, setResolving] = useState(() => parseStartParam() !== null);

  useEffect(() => {
    const sp = parseStartParam();
    if (!sp) return;

    api<MeOut>("GET", "/me")
      .then((me) => {
        const found = me.groups.find(
          (g) => g.telegram_chat_id === sp.telegramChatId,
        );
        if (!found) { nav("/", { replace: true }); return; }
        const id = found.id;
        const dest =
          sp.kind === "history" ? `/groups/${id}/history` :
          sp.kind === "add" ? `/groups/${id}/expenses/new` :
          sp.kind === "receipt" ? `/groups/${id}/receipt` :
          sp.kind === "settle" ? `/groups/${id}/settle` :
          sp.kind === "pending" ? `/inbox?chat=${id}` :
          sp.kind === "receipt_detail" ? `/groups/${id}/receipts/${sp.receiptId}` :
          `/groups/${id}`;
        nav(dest, { replace: true });
      })
      .catch(() => nav("/", { replace: true }))
      .finally(() => setResolving(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (resolving) {
    return (
      <div className="min-h-screen bg-tg-bg flex items-center justify-center">
        <p className="text-tg-hint">Loading…</p>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/inbox" element={<Inbox />} />
      <Route path="/groups/:id" element={<Group />} />
      <Route path="/groups/:id/balances" element={<Balances />} />
      <Route path="/groups/:id/history" element={<History />} />
      <Route path="/groups/:id/expenses/new" element={<AddExpense />} />
      <Route path="/groups/:id/receipt" element={<Receipt />} />
      <Route path="/groups/:id/settle" element={<Settle />} />
      <Route path="/groups/:id/expenses/:expenseId" element={<ExpenseDetail />} />
      <Route path="/groups/:id/receipts/:receiptId" element={<ReceiptDetail />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
